<ng-container *ngIf="{ value: (fullItemAccess$ | async) ?? false } as fullItemAccess">
  <div class="estimate-items-list" *ngIf="!mobileView" [class.disabled]="readonly">

    <div *ngIf="estimateVersion" cdkDropList (cdkDropListDropped)="dropAction($event)" class="items-list">
      <div *ngFor="let estimateItem of estimateVersion.items; let i = index"
           class="estimate-items-list-item" cdkDrag
           (cdkDragStarted)="dragging = true"
           (cdkDragEnded)="dragging = false"
           (click)="readonly ? null : editItem(estimateItem, fullItemAccess.value)"
           [cdkDragDisabled]="readonly"
      >
        <div class="estimate-item-left flex-fill"
             (mouseenter)="itemPrice.classList.add('primary-dark-color')"
             (mouseleave)="itemPrice.classList.remove('primary-dark-color')"
             #estimateItemLeft
        >
          <app-icon class="clickable hide" src="6dots" cdkDragHandle
                    [class.hide]="(estimateVersion.items ?? []).length < 2"
                    [class.disabled-semitransparent]="readonly"
                    (click)="$event.stopPropagation()"
          ></app-icon>
          <div class="item-index" [class.two-char]="i>=9" [style.opacity]="dragging ? '0' : '100'">{{i+1}}</div>
          <div class="item-name" [class.two-char]="i>=9">{{estimateItem.name}}</div>
        </div>
        <div class="estimate-item-right">
          <div class="item-qty-price" [id]="'qty-price-'+i" (click)="$event.stopPropagation()">
            <div class="item-qty">
              <h4 class="item-qty-text">Qty</h4>
              <mat-form-field appearance="outline" class="width--38 height--24"
                (click)="$event.stopPropagation()"
                [class.disabled]="readonly"
                [class.filled]="readonly"
              >
                <input matInput style="bottom: 8px"
                       maxlength="4"
                       [defaultValue]="estimateItem.quantity"
                       (input)="qtyFieldInput($event, estimateItem, false, 'qty-price-'+i)"
                       (focusout)="qtyFocus$.next(false)"
                       (focus)="qtyFocus$.next(true)"
                       [id]="'qty-input'+i"
                       autocomplete="off"
                       class="tac fw-600 position-relative"
                       inputmode="numeric"
                       (keydown)="digitsOnly($event)"
                       (paste)="onPaste($event)"
                       ondrop="return false;"
                       [readonly]="readonly"
                >
              </mat-form-field>
            </div>
            <div class="item-price" (click)="editItem(estimateItem, fullItemAccess.value)"
                 (mouseenter)="estimateItemLeft.classList.add('primary-dark-color')"
                 (mouseleave)="estimateItemLeft.classList.remove('primary-dark-color')"
            >
              <h4 class="w-100 tar" #itemPrice>
                ${{(+getItemPrice(estimateItem)).toFixed(2)}}
              </h4>
            </div>
          </div>
          <div class="item-info-edit" (click)="$event.stopPropagation()">
            <app-workflow-item-info [eoIItem]="estimateItem"
                                    [index]="i"
                                    [hoveredItemIndex]="hoveredItemIndex"
                                    *ngIf="infoIconDistancesFromTop.length > 0"
                                    [distanceFromTop]="infoIconDistancesFromTop[i]"
                                    [salesTaxPercentage]="estimateVersion.clientSalesTaxPercentage!"
                                    [businessId]="(businessId$ | async)!"
            ></app-workflow-item-info>
            <app-icon class="item-info-icon" src="item-info"
                      (mouseenter)="hoveredItemIndex = i"
                      (mouseleave)="hoveredItemIndex = null"
                      [id]="'info-icon-'+i"
                      [style.pointer-events]="'auto'"
            ></app-icon>
            <app-icon class="clickable dots3-icon" src="3dots"
                      [matMenuTriggerFor]="readonly ? null :itemActionsMenu"
                      [matMenuTriggerData]="{ item: estimateItem, index: i }"
                      [class.disabled-semitransparent]="readonly"
            ></app-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="add-estimate-item"
         [class.no-items]="(estimateVersion.items ?? []).length === 0"
         [class.disabled-semitransparent]="!estimateVersion.clientSalesTaxPercentage || readonly"
         (click)="estimateVersion.clientSalesTaxPercentage && !readonly ? openAddEstimateItemModal(fullItemAccess.value) : null"
    >
      <app-icon class="se-icon-button" [class.no-hover]="!estimateVersion.clientSalesTaxPercentage" src="plus"></app-icon>
      <p class="add-estimate-item-button-text">Item</p>
    </div>

    <app-estimate-summary *ngIf="(estimateVersion.items ?? []).length > 0"
                          [estimate]="estimate" [estimateVersion]="estimateVersion"
                          (depositFocus)="itemsListFocus.emit($event)"
                          [readonly]="readonly"
    ></app-estimate-summary>

  </div>

  <div class="estimate-items-list-mobile" *ngIf="mobileView" [class.disabled]="readonly">

    <div *ngIf="(estimateVersion.items ?? []).length > 0" class="estimate-items-mobile">
      <div *ngFor="let estimateItem of estimateVersion.items let i = index"
           class="estimate-item-mobile"
      >

        <div class="estimate-item-mobile-top" (click)="editItem(estimateItem, fullItemAccess.value)">
          <div class="name">{{estimateItem.name}}</div>
          <div class="actions" (click)="$event.stopPropagation()">
            <app-icon class="dots3-icon" src="3dots" [matMenuTriggerFor]="readonly ? null : itemActionsMenu"
                      [matMenuTriggerData]="{ item: estimateItem, index: i }"
                      [class.disabled-semitransparent]="readonly"
            ></app-icon>
            <app-icon class="item-info-icon" src="item-info" (click)="openItemInfoMobile(estimateItem)" [style.pointer-events]="'auto'"></app-icon>
          </div>
        </div>

        <div class="divider"></div>
        <div class="estimate-item-mobile-bottom" (click)="editItem(estimateItem, fullItemAccess.value)">
          <div class="qty-block">
            <div class="label">Qty</div>
            <mat-form-field appearance="outline" class="width--38 height--24" (click)="$event.stopPropagation()" [class.disabled]="readonly">
              <input matInput style="bottom: 8px"
                     maxlength="4"
                     [defaultValue]="estimateItem.quantity"
                     (focusout)="qtyFocus$.next(false)"
                     (focus)="qtyFocus$.next(true)"
                     (input)="qtyFieldInput($event, estimateItem, true)"
                     autocomplete="off"
                     class="tac fw-600 position-relative"
                     inputmode="numeric"
                     (keydown)="digitsOnly($event)"
                     (paste)="onPaste($event)"
                     ondrop="return false;"
                     [readonly]="readonly"
              >
            </mat-form-field>
          </div>
          <div class="total d-flex">
            <div>$</div>
            <div class="fw-600">{{(+getItemPrice(estimateItem)).toFixed(2)}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="add-estimate-item"
         [class.no-items]="(estimateVersion.items ?? []).length === 0"
         [class.disabled-semitransparent]="!estimateVersion.clientSalesTaxPercentage || readonly"
         (click)="estimateVersion.clientSalesTaxPercentage && !readonly ? openAddEstimateItemModal(fullItemAccess.value) : null"
    >
      <app-icon class="se-icon-button" [class.no-hover]="!estimateVersion.clientSalesTaxPercentage" src="plus"></app-icon>
      <p class="add-estimate-item-button-text">Item</p>
    </div>

    <app-estimate-summary *ngIf="(estimateVersion.items ?? []).length > 0"
                          [estimate]="estimate" [estimateVersion]="estimateVersion"
                          (depositFocus)="itemsListFocus.emit($event)"
                          [readonly]="readonly"
    ></app-estimate-summary>
  </div>

  <mat-menu #itemActionsMenu xPosition="before" class="no-margin">
    <ng-template matMenuContent let-item="item" let-index="index">
      <mat-option (click)="editItem(item, fullItemAccess.value)">Edit</mat-option>
      <mat-option (click)="duplicateItem(item, index)">Duplicate</mat-option>
      <mat-option (click)="deleteItem(index)">Delete</mat-option>
    </ng-template>
  </mat-menu>

</ng-container>
